export const config = {
  aiChatServiceUrl: '/_serverless/wix-ai-assistant-bot',
  duplexerSocketsServerUrl: 'duplexer.wix.com',
};
